import { render, staticRenderFns } from "./DesignElementPreview.vue?vue&type=template&id=621a841c&scoped=true&"
import script from "./DesignElementPreview.vue?vue&type=script&lang=js&"
export * from "./DesignElementPreview.vue?vue&type=script&lang=js&"
import style0 from "./DesignElementPreview.vue?vue&type=style&index=0&id=621a841c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a841c",
  null
  
)

export default component.exports